import { authErrorHandler } from '@/services/error/authHandler.js';

export default {
  async sendTrackPage({ commit }, { url }) {
    try {
      const response = await fetch('/api/metric/track-page', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          url: url,
        }),
      });

      if (!response.ok) {
        console.warn('Metrics not sent');
      }
      if (response.statusText === 'Unauthorized') {
        authErrorHandler(response);
      }
    } catch (error) {
      console.log(error);
    }
  },
};
